import styled from 'styled-components'

export const TitleWrapper = styled.div`
  height: 56px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`

export const Actions = styled.div`
  margin-left: auto;
`

export const UpdateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 38px;
`

export const AccordionTitle = styled.h5`
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
`

export const Panels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`
